module.exports = __webpack_public_path__ + "static/full-colour-print-marketing-48a1603c5df39654259700f334da4900.jpg";